import React, { useContext } from 'react';
import LocalizationContext from '../../contexts/LocalizationContext';
import IFormSubmitResult from '../../interfaces/IFormSubmitResult';
import ConfirmPopup from './ConfirmPopup';
import FormSubmitResult from './FormSubmitResult';

interface FormSubmitFailedProps {
    submitResult?: IFormSubmitResult;
    onClose: () => void;
    onTryAgain?: () => void;
    [x: string]: any;
}

const SubmitFailedDialog = ({ submitResult, onClose, onTryAgain, ...otherProps }: FormSubmitFailedProps) => {
    const localization = useContext(LocalizationContext);

    return (
        <ConfirmPopup
            {...otherProps}
            fullWidth
            maxWidth='sm'
            open={Boolean(submitResult)}
            confirmText={onTryAgain ? localization.strings.retry : localization.strings.ok}
            title={localization.strings.failedSubmit}
            content={<FormSubmitResult result={submitResult} />}
            onClose={onClose}
            allowCancel={otherProps.allowCancel}
            onConfirm={() => {
                onClose();
                if (onTryAgain) onTryAgain();
            }}
        />
    );
};

export default SubmitFailedDialog;
